import React from 'react';
import atoms from 'ctsutheme/components/atoms';
import { CanUserAccessCirbDocs } from 'appconstants/Permission';
import { BoolToString } from 'components';
import { getTableColumns } from 'helpers';
import { FasFile } from 'assets/icons';
import { RenderElement } from 'components/RenderHelpers';

const {
  IconButton,
  Tooltip
} = atoms;


const ApprovalInfoColumns = [
  ['approvalType', 'string', 'Approval Type', 'left', true],
  ['versionDate', 'string', 'Protocol Version Date', 'left', true],
  ['reviewType', 'string', 'Review Type', 'left', true],
  ['meetingDate', 'string', 'Meeting Date', 'center', true],
  ['approvalDate', 'string', 'Approval Date', 'center', true],
  ['expiryDate', 'string', 'Expiry Date', 'lcentereft', true],
  ['rssMeetingDate', 'string', '(RSS) Meeting Date', 'center', true],
  ['rssApprovalDate', 'string', '(RSS) Approval Date', 'center', true],
  ['rssVersionDate', 'string', '(RSS) Version Date', 'center', true],
  ['rssExpiryDate', 'string', '(RSS) Expiry Date', 'center', true],
  ['eventComments', 'string', 'Event Comments', 'left', true]
];

const ProtApprovalInfoColumns = [
  ...getTableColumns(ApprovalInfoColumns),
  {
    name: 'isApplyApprovalToSite',
    type: 'string',
    label: 'Applied To Sites',
    align: 'center',
    filterable: true,
    renderCell: data => <BoolToString boolValue={data.isApplyApprovalToSite} />
  }, {
    name: 'cirbEventId',
    type: 'string',
    label: 'Document(s)',
    align: 'center',
    sort: false,
    renderCell: (data, rowEvents) => (
      <RenderElement access={CanUserAccessCirbDocs()}>
        <Tooltip
          tooltipplacementbottom="true"
          title="View Document(s)"
          aria-label="View Document(s)"
        >
          <IconButton
            key="UserCirbDocs"
            color="secondary"
            onClick={() => rowEvents[0](data.cirbEventId)}
          >
            <FasFile />
          </IconButton>
        </Tooltip>
      </RenderElement>
    )
  }
];


export default ProtApprovalInfoColumns;
